module.exports = __webpack_public_path__ + "static/product-condition-badge-883b47af007d0109a06ae6854833013b.jpg";